import { ReactComponent as Pay1 } from '@src/assets/pay_type_1.svg'
import { ReactComponent as Pay2 } from '@src/assets/pay_type_2.svg'
import { ReactComponent as Pay3 } from '@src/assets/pay_type_3.svg'
import { ReactComponent as Pay4 } from '@src/assets/pay_type_4.svg'
import { ReactComponent as Pay5 } from '@src/assets/pay_type_5.svg'
import { ReactComponent as Pay6 } from '@src/assets/pay_type_6.svg'
import style from '../PaymentMethods.module.scss'

export const Cards = () => (
  <div className={style.cards}>
    <h2 className={style.bm} id="ATM">Оплата банковской картой</h2>
    <p>
      Оплата банковской картой VISA, MasterCard, БЕЛКАРТ через систему
      <span className={style.assistColor}> Assist Belarus</span>
    </p>
    <div className={style.pay_type_items}>
      <div className={style.item}><Pay1 /></div>
      <div className={style.item}><Pay2 /></div>
      <div className={style.item}><Pay3 /></div>
      <div className={style.item}><Pay4 /></div>
      <div className={style.item}><Pay5 /></div>
      <div className={style.item}><Pay6 /></div>
    </div>

    <div className={style.punkts}>
      <div className={style.numb}>1</div>
      <div className={style.n_text}>
        Оплата производится через интернет в режиме
        реального времени непосредственно после оформления заказа.
      </div>
    </div>
    <div className={style.punkts}>
      <div className={style.numb}>2</div>
      <div className={style.n_text}>
        Для совершения финансовой операции подходят
        карточки международных платежных систем VISA (всех видов), MasterCard
        (в том числе Maestro), эмитированные любым банком мира, в том числе
        эмитированные АСБ «Беларусбанк», а также карты системы БЕЛКАРТ.
      </div>
    </div>

    <h3>О процедуре оплаты по карточкам БЕЛКАРТ:</h3>
    <div className={style.text_container}>
      <div className={style.before}>
        <p>
          При выборе оплаты заказа с помощью банковской карты, обработка
          платежа (включая ввод номера банковской карты) производится ООО
          «Компанией электронных платежей «АССИСТ» с использованием
          программно-аппаратного комплекса системы электронных платежей Assist
          Belarus, которая прошла международную сертификацию.
        </p>
        <p>
          В системе, обеспечивающей безопасность платежей, используется
          защищённый протокол TLS для передачи конфиденциальной информации от
          клиента на сервер и дальнейшей обработки в процессинговом центре.
          Это значит, что конфиденциальные данные плательщика (реквизиты
          карты, регистрационные данные и др.) не поступают в
          интернет-магазин, их обработка полностью защищена, и никто не может
          получить персональные и банковские данные клиента. Кроме того, при
          обработке платежей по банковским картам, используется безопасная
          технология 3D-Secure, которую в обязательном порядке требуют
          международные платёжные системы VISA и MasterCard.
        </p>
      </div>
      <div className={style.other_functions}>
        Читать
        полностью
      </div>
    </div>

    <h3 className={style.pay}>Порядок оплаты:</h3>

    <div className={style.punkts}>
      <div className={style.numb}>1</div>
      <div className={style.n_text}>Выбрать способ отплаты картой on-line.</div>
    </div>
    <div className={style.punkts}>
      <div className={style.numb}>2</div>
      <div className={style.n_text}>
        После нажатия на кнопку «Подтвердить и оплатить»
        система направит вас на сайт провайдера электронных платежей
        belassist.by, обеспечивающего безопасность платежей. Авторизационный
        сервер устанавливает с покупателем соединение по защищённому протоколу
        TLS и принимает от покупателя параметры его банковской карты (номер
        карты, дата окончания действия карты, имя держателя карты в той
        транскрипции, как оно указано на банковской карте, а также номер CVC2
        либо CVV2, указанные на обратной стороне карты). Операция оплаты
        банковской картой онлайн полностью конфиденциальна и безопасна.
      </div>
    </div>
    <div className={style.punkts}>
      <div className={style.numb}>3</div>
      <div className={style.n_text}>
        Ваши персональные данные и реквизиты карточки
        вводятся не на странице нашего сайта, а на авторизационной странице
        платежной системы. Доступ к этим данным осуществляется по протоколу
        безопасной передачи данных TLS, также применяются технологии
        безопасных интернет-платежей Verified by Visa и MasterCard SecureСode.
      </div>
    </div>

    <p className={style.pay_p}>
      К оплате принимаются карты платежных систем Visa,
      MasterCard и БЕЛКАРТ, эмитированные любыми банками мира. Мы рекомендуем
      заранее обратиться в свой банк, чтобы удостовериться в том, что ваша
      карта может быть использована для платежей в сети интернет.
    </p>

    <div className={style.banks}>
      <div className={style.text_container}>
        <ul className={style.before}>
          <li><a href="https://belarusbank.by/">Беларусбанк</a></li>
          <li><a href="https://www.belapb.by/">Белагропромбанк</a></li>
          <li><a href="https://www.bveb.by/">Белвнешэкономбанк</a></li>
          <li><a href="https://www.belgazprombank.by/">Белгазпромбанк</a></li>
          <li><a href="https://www.belinvestbank.by/">Белинвестбанк</a></li>
          <li><a href="https://www.mtb.by/">Минский транзитный банк</a></li>
        </ul>
        <ul>
          <li><a href="https://www.paritetbank.by/">Паритетбанк</a></li>
          <li><a href="https://www.priorbank.by/">Приорбанк</a></li>
          <li><a href="https://vtb-bank.by/">ВТБ Банк</a></li>
          <li><a href="https://www.bsb.by/">БелСвиссБанк</a></li>
          <li><a href="https://www.bpsb.by/">Белпромстройбанк</a></li>
          <li><a href="https://www.alfabank.by/">Альфа-банк</a></li>
        </ul>
      </div>
    </div>
  </div>
)
